// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"X3-z"};